import { createAxios } from '@/lib/http';
import { dropToken } from '@/lib/auth/session';
import { ROUTES } from '@/constants/routes';
import { env } from '@/env';

const axiosInstance = createAxios({
  baseURL: env.VITE_API_BASE_URL,
  timeoutMs: env.VITE_API_TIMEOUT_MS,
  authHeaderName: env.VITE_AUTH_HEADER_NAME,
  onUnauthorized: () => {
    dropToken();
    if (typeof window !== 'undefined' && window.location.pathname !== ROUTES.login) {
      window.location.href = ROUTES.login;
    }
  },
});

export default axiosInstance;
